import { ChooseRecurrence } from "@molecules/ChooseRecurrence";
import { PlanMobileNavigator } from "@/components/molecules/PlanMobileNavigator";
import { PlanSlider } from "../PlanSlider";
import type { TPlanBody } from "./types";

export const PlanBody = ({ plan }: TPlanBody) => {
  const PlanBodyElement = document.createElement("div");
  PlanBodyElement.id = "plan-body";
  PlanBodyElement.className = "w-full bg-white";

  PlanBodyElement.appendChild(ChooseRecurrence(plan));

  PlanBodyElement.appendChild(
    PlanSlider({ allPlans: plan.allPlansPerRecurrence.month }),
  );

  PlanBodyElement.appendChild(
    PlanMobileNavigator({
      slideNumber: plan.allPlansPerRecurrence.month.length,
    }),
  );

  return PlanBodyElement;
};
